import { useState } from 'react';
import { Box } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import { avatarList } from 'enrollment/app/constants';
import { chooseAvatarAction, chooseFamilyAvatarAction } from './AvatarActions';
import {
  AvatarListIcon,
  AvatarSelectionListBox,
  StyledTypography,
} from './AvatarStyled';

interface AvatarSelectionProps {
  scope: 'family' | 'subscriber';
}
export const AvatarSelection = ({ scope }: AvatarSelectionProps) => {
  const { t } = useTranslation('pages.enrollmentDashboard');
  const dispatch = useDispatch();

  const state = useSelector((state: any) => state?.enrollment);
  const selectorState = state?.authentication?.redirectLink;
  const chosenDisplay = state?.chooseAvatar?.chosenDisplay;
  const isCropped = state?.chooseAvatar?.isCropped;

  const [selectedAvatarId, setSelectedAvatarId] = useState<string | null>(null);
  const [announcement, setAnnouncement] = useState('');

  const handleAvatarSelection = (list: any, selectorState: string) => {
    setSelectedAvatarId(list.id);
    setAnnouncement(`Selected avatar: ${list.name}`);

    if (selectorState === '/enrollment/profile/edit') {
      dispatch(chooseAvatarAction(list, '/enrollment/profile/edit'));
    }
    if (selectorState === '/enrollment/family') {
      dispatch(chooseFamilyAvatarAction(list, '/enrollment/family'));
    }
  };

  return (
    <Box role="group" aria-labelledby="idref1">
      <div role="alert" aria-live="assertive" className="sr-only">
        {announcement}
      </div>

      <StyledTypography variant="overline" gutterBottom id="idref1">
        {t('avatarSelectionTitle')}
      </StyledTypography>

      <AvatarSelectionListBox>
        {avatarList?.map((list) => {
          const isSelected = selectedAvatarId === list.id;

          return (
            <li key={list.id}>
              <Button
                type="button"
                disabled={
                  scope === 'subscriber' &&
                  chosenDisplay === 'picture' &&
                  isCropped
                }
                onClick={() => handleAvatarSelection(list, selectorState)}
                aria-label={list.name}
                aria-pressed={isSelected}
                className={isSelected ? 'selected' : ''}
                style={{ position: 'relative' }}
              >
                <AvatarListIcon
                  data-testid="avatarListIcon"
                  role="presentation"
                  dangerouslySetInnerHTML={{ __html: list.code }}
                />
                {isSelected && <span className="sr-only">selected</span>}
                {isSelected && (
                  <i
                    className="ph-fill ph-check-fat checkmark"
                    aria-hidden="true"
                    role="presentation"
                  ></i>
                )}
              </Button>
            </li>
          );
        })}
      </AvatarSelectionListBox>
    </Box>
  );
};
